/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './round-switcher.stache';
import can from 'can';

Component.extend({
    tag: 'round-switcher',
    template: template,
    leakScope: false,
    viewModel: {
        round: null,
        define: {
            selectedRound: {
                // holds internal round index
                type: 'number',
                value: 1,
            },
            rounds: {
                Type: can.List,
                value: null,
            },
            round: {
                type: 'number',
                value: 1,
            },
        },
        increase(index, number) {
            return index + number;
        },
    },
    events: {
        '.s-switcher-btn click'($el) {
            if (!$el.hasClass('is-disabled')) {
                let roundIndex = parseInt($el.attr('data-round-number'));
                this.viewModel.attr('selectedRound', roundIndex);
            }
        },

        '{scope} selectedRound'(scope, event, selectedRound) {
            this.viewModel.attr('round', selectedRound);
        },
    },
});
